import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Popover,
  FormControl,
  InputLabel,
  FormHelperText,
  MenuItem,
  Select,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  CircularProgress,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  InputAdornment,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Group,
  Close,
  DonutLarge,
  ArrowForwardIos,
  Assignment,
  Edit,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { Skeleton, Autocomplete } from "@material-ui/lab";

import SelectImg from "../../../../../assets/svg/select.svg";

import Nodata from "../../../../../assets/svg/nodata.svg";

import { makeStyles, useTheme } from "@material-ui/styles";
import { FinanceService, AdminService } from "../../../../../utils/web_config";
import {
  useCommissionTypes,
  useTransactionTypes,
  useInternalAccounts,
  useOrganizations,
} from "../../../hooks/use_hooks";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Commissions(props) {
  const classes = useStyles();
  const history = useHistory();

  const orgs = useOrganizations();

  const [accountData, setAccountData] = useState({});

  const commissionTypes = useCommissionTypes();
  const transactionTypes = useTransactionTypes();
  const internalAccounts = useInternalAccounts();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [commissions, setCommissions] = useState({
    loading: false,
    saving: false,
    open: false,
    selected: "none",
    index: "none",
    data: [],
  });

  const [typesOpen, setTypesOpen] = useState(false);
  const [bankCode, setBankCode] = useState({ value: "", error: "" });
  const [bankAccount, setBankAccount] = useState({ value: "", error: "" });
  const [bankAccountName, setBankAccountName] = useState({ value: "", error: ""});
  const [commissionType, setType] = useState({ value: "", error: "" });
  const [commissionName, setName] = useState({ value: "", error: "" });
  const [commissionTransactionType, setTransactionType] = useState({
    value: "",
    error: "",
  });
  const [commissionComputationMode, setComputationMode] = useState({
    value: "",
    error: "",
  });
  const [commissionVat, setVat] = useState({ value: "", error: "" });
  const [commissionValue, setValue] = useState({ value: "", error: "" });
  const [commissionDebitedAccountNumber, setDebitedAccountNumber] = useState({
    value: "",
    error: "",
  });

  const [organization, setOrganization] = useState({ value: {}, error: "" });
  const [organizationType, setOrganizationType] = useState({
    value: "CENTRIKA",
    error: "",
  });

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getCommissions(accountData.token);
    //getPrivileges(data.token, null, true);
  }, []);

  ///////////////////////////////////

  const onTypeChange = (event) => {
    if (event.target.value == "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_type")
            }
          </Translate>
        ),
      });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };

  const onOrganizationChange = (event, v) => {
    if (v.organization_id == null) {
      setOrganization({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("roles.forms.hints.role_organization")
            }
          </Translate>
        ),
      });
    } else {
      setOrganization({ value: v, error: "" });
    }
  };

  const onOrgTypeChange = (event) => {
    if (event.target.value === "") {
      setOrganizationType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("organizations.forms.labels.org_type")
            }
          </Translate>
        ),
      });
    } else {
      setOrganizationType({ value: event.target.value, error: "" });
    }
  };
  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_name")
            }
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onTransactionTypeChange = (event) => {
    if (event.target.value === "") {
      setTransactionType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_transaction_type")
            }
          </Translate>
        ),
      });
    } else {
      setTransactionType({ value: event.target.value, error: "" });
    }
  };
  const onComputationModeChange = (event) => {
    if (event.target.value === "") {
      setComputationMode({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_computation_mode")
            }
          </Translate>
        ),
      });
    } else {
      setComputationMode({ value: event.target.value, error: "" });
    }
  };

  const onValueChange = (event) => {
    if (event.target.value === "") {
      setValue({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_value")
            }
          </Translate>
        ),
      });
    } else {
      setValue({ value: event.target.value, error: "" });
    }
  };
  const onVatChange = (event) => {
    if (event.target.value === "") {
      setVat({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_vat")
            }
          </Translate>
        ),
      });
    } else {
      setVat({ value: event.target.value, error: "" });
    }
  };
  const onDebitedAccountNumberChange = (event) => {
    if (event.target.value === "") {
      setDebitedAccountNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "commissions.forms.hints.commission_debited_account_number"
              )
            }
          </Translate>
        ),
      });
    } else {
      setDebitedAccountNumber({ value: event.target.value, error: "" });
    }
  };

  const onBankCode = (event) => {
    if (event.target.value === "") {
      setBankCode({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_settlement_bank_code")
            }
          </Translate>
        ),
      });
    } else {
      setBankCode({ value: event.target.value, error: "" });
    }
  };

  const onBankAccount = (event) =>{
    if(event.target.value === ""){
      setBankAccount({ 
        value: "",
      error: "Please provide valid bank account"})
    }else{
      setBankAccount({ value: event.target.value, error: ""});
    }
  }

  const onBankAccountName = (event) => {
    if (event.target.value === "") {
      setBankAccountName({
        value: "",
        error: "Please provide valid account holder name"
      })
    } else {
      setBankAccountName({ value: event.target.value, error: "" });
    }
  }

  /////////////////////////
  const onCreateClick = () => {
    if (commissionType.value == "" ) {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_type")
            }
          </Translate>
        ),
      });
    } else if (
      organization.value?.organization_id == null &&
      (commissionType.value == "CUSTOM" || commissionType.value == "FEES_COMM")&&
      !commissions.edit
    ) {
      setOrganization({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("roles.forms.hints.role_organization")
            }
          </Translate>
        ),
      });
    } else if (commissionName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_name")
            }
          </Translate>
        ),
      });
    } else if (commissionTransactionType.value === "" && (commissionType.value == "CUSTOM" || commissionType.value == "GENERIC")) {
      setTransactionType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_transaction_type")
            }
          </Translate>
        ),
      });
    } else if (commissionComputationMode.value === "") {
      setComputationMode({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_computation_mode")
            }
          </Translate>
        ),
      });
    } else if (commissionValue.value === "") {
      setValue({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_value")
            }
          </Translate>
        ),
      });
    } else if (commissionVat.value === "") {
      setVat({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("commissions.forms.hints.commission_vat")
            }
          </Translate>
        ),
      });
    } else if (commissionDebitedAccountNumber.value === "" && (commissionType.value == "CUSTOM" || commissionType.value == "GENERIC")) {
      setDebitedAccountNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "commissions.forms.hints.commission_debited_account_number"
              )
            }
          </Translate>
        ),
      });
    } else if (bankCode.value === "" && (commissionType.value == "FEES_COMM")){
      setBankCode({ value: "", error: "Please select beneficial bank"})
    } else if (bankAccount.value === "" && (commissionType.value == "FEES_COMM" )){
      setBankAccount({ value: "", error: "Please enter valid bank account"})
    } else if (bankAccountName.value === "" && (commissionType.value == "FEES_COMM")){
      setBankAccountName({ value: "", error: "Please enter bank account holder name"});
    } else {
      createCommission();
    }
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }

    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  //////////////////////
  const getCommissions = (token) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
    setCommissions({ ...commissions, loading: true });
    console.log("getting commissions.....");

    usersInstance
      .get(new FinanceService().GET_ALL_COMMISSIONS + "?page=0&per_page=1000&commission_type_id=3")
      .then(function (response) {
        setCommissions({ ...commissions, loading: false });
        const d = response.data;
        setCommissions({ ...commissions, data: d.data });
      })
      .catch(function (error) {
        setCommissions({ ...commissions, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////

  const clearUserInfo = () => {
    setType({ value: "", error: "" });
    setName({ value: "", error: "" });
    setTransactionType({ value: "", error: "" });
    setOrganization({ value: {}, error: "" });
    setComputationMode({ value: "", error: "" });
    setVat({ value: "", error: "" });
    setValue({ value: "", error: "" });
    setDebitedAccountNumber({ value: "", error: "" });
  };
  ///////////////////////////////

  const createCommission = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    if (commissions.edit) {
      updateCommission();
      return;
    }
    setCommissions({ ...commissions, saving: true });

    var data, url;
    if (commissionType.value == "CUSTOM") {
      url = new FinanceService().CREATE_CUSTOM_COMMISSION;
      data = {
        organization_type: organization.value.organization_type,
        organization_id: organization.value.organization_id,
        name: commissionName.value,
        transaction_type: commissionTransactionType.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        debited_account_number: commissionDebitedAccountNumber.value,
      };
    } else if (commissionType.value == "FEES_COMM"){
      url = new FinanceService().CREATE_OTHER_COMMISSION
      data = {
        organization_type: organization.value.organization_type,
        commission_type_id: 3,
        organization_id: organization.value.organization_id,
        name: commissionName.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        credited_bank_account: bankAccount.value,
        credited_bank_name: bankAccountName.value,
        credited_bank_code: bankCode.value
      };
    } else {
      url = new FinanceService().CREATE_GENERIC_COMMISSION;
      data = {
        organization_type: organizationType.value,
        name: commissionName.value,
        transaction_type: commissionTransactionType.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        debited_account_number: commissionDebitedAccountNumber.value,
      };
    }

    console.log("Creating commission .....");

    createInstance
      .post(url, data)
      .then(function (response) {
        setCommissions({ ...commissions, saving: false, open: false });
        var d = response.data;

        var comms = commissions.data;

        comms.unshift(d.data);
        setCommissions({
          ...commissions,
          data: comms,
          open: false,
        });

        clearUserInfo();

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setCommissions({ ...commissions, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////////

  const toggleCommissionStatus = (id, index, status) => {
    const commInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    var comm = commissions.data[index];
    var comm2 = comm;

    console.log("toggling commission .....");

    var url;
    if (status == "ENABLED") {
      url = new FinanceService().DISABLE_COMMISSION + id;
      comm["status"] = "DISABLED";
    } else {
      url = new FinanceService().ENABLE_COMMISSION + id;
      comm["status"] = "ENABLED";
    }

    var comms = commissions.data;

    comms[index] = comm;
    setCommissions({ ...commissions, data: comms, toggling: index });

    commInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setCommissions({ ...commissions, toggling: null });

        notify("success", d.message);
      })
      .catch(function (error) {
        comm2["status"] = status;

        comms[index] = comm2;

        setCommissions({ ...commissions, data: comms, toggling: null });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////

  const updateCommission = () => {
    const upInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setCommissions({ ...commissions, saving: true });

    var data, url;
    if (commissionType.value == "CUSTOM") {
      url = new FinanceService().UPDATE_COMMISSION + commissions.selected.id;
      data = {
        organization_type: organization.value.organization_type,
        organization_id: organization.value.organization_id,
        name: commissionName.value,
        transaction_type: commissionTransactionType.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        debited_account_number: commissionDebitedAccountNumber.value,
      };
    } else if (commissionType.value == "FEES_COMM") {
      url = new FinanceService().UPDATE_OTHER_COMMISSION + commissions.selected.id;
      data = {
        name: commissionName.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        credited_bank_account: bankAccount.value,
        credited_bank_name: bankAccountName.value,
        credited_bank_code: bankCode.value
      };
    }  else {
      url = new FinanceService().UPDATE_COMMISSION + commissions.selected.id;
      data = {
        organization_type: organizationType.value,
        name: commissionName.value,
        transaction_type: commissionTransactionType.value,
        computation_mode: commissionComputationMode.value,
        commission_value: commissionValue.value,
        vat: commissionVat.value,
        debited_account_number: commissionDebitedAccountNumber.value,
      };
    }

    console.log("Updating commission .....");

    upInstance
      .put(url, data)
      .then(function (response) {
        setCommissions({ ...commissions, saving: false, open: false });
        var d = response.data;

        var comms = commissions.data;

        comms[commissions.index] = d.data;
        setCommissions({
          ...commissions,
          data: comms,
          selected: "none",
          open: false,
          edit: false,
        });

        clearUserInfo();

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setCommissions({ ...commissions, saving: false });
        var e = error.message;

        console.log(error);
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Dialog
        open={typesOpen}
        onClose={() => setTypesOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Commission types"}</DialogTitle>
        <DialogContent>
          {commissionTypes.status == "error" ||
          commissionTypes.status == "empty" ? (
            <Box p={5} display="flex" justifyContent="center">
              {commissionTypes.status == "error" ? (
                <Typography>
                  Error loading commission types, try to refresh
                </Typography>
              ) : (
                <Typography>
                  There are no commission types available yet.
                </Typography>
              )}
            </Box>
          ) : (
            <List>
              {commissionTypes.status != "loading"
                ? commissionTypes.data?.map((comm, i) => (
                    <>
                      {i != 0 && i != commissionTypes.data.length && (
                        <Divider variant="middle" />
                      )}
                      <ListItem
                        key={i}
                        dense
                        button
                        // onMouseEnter={() =>
                        //   setItemOver({ index: i, priv: priv, role: false })
                        // }
                        // onMouseLeave={() => setItemOver("none")}
                        // onClick={(e) => setAnchorEditPriv(e?.currentTarget)}
                        // selected={itemOver.index == i}
                      >
                        <ListItemText
                          primary={comm.name}
                          secondary={comm.description}
                        />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            checked={comm.status == "ENABLED"}
                            disabled
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  ))
                : [1, 2, 3, 4, 5].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setTypesOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* ////////////////////////////// */}
      <Dialog
        open={commissions.open}
        maxWidth="sm"
        fullWidth
        onClose={() =>
          setCommissions({ ...commissions, open: false, edit: false })
        }
      >
        <DialogTitle id="new-op">Create new commission</DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                commissionType.error !== "" || commissionTypes.status == "error"
              }
              disabled={commissionTypes.status == "error" || commissions.edit}
            >
              <InputLabel>
                <Translate id="commissions.forms.labels.commission_type" />
              </InputLabel>
              <Select
                label={
                  <Translate id="commissions.forms.labels.commission_type" />
                }
                value={commissionType.value}
                onChange={onTypeChange}
              >
                {commissionTypes.data?.map((comm, i) => (
                  <MenuItem value={comm.code}>{comm.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {commissionTypes.status == "error"
                  ? "Error loading commission types, please reload"
                  : commissionType.error}
              </FormHelperText>
            </FormControl>
          </Box>
          {commissionType.value != "CUSTOM" && commissionType.value != "FEES_COMM" && (
            <Box mt={2}>
              <FormControl
                className={classes.formControl}
                fullWidth
                variant="outlined"
                size="small"
                error={organizationType.error !== ""}
                disabled={commissions.edit}
              >
                <InputLabel id="type">
                  <Translate id="organizations.forms.labels.org_type" />
                </InputLabel>
                <Select
                  label={<Translate id="organizations.forms.labels.org_type" />}
                  value={organizationType.value}
                  onChange={onOrgTypeChange}
                >
                  <MenuItem value="CENTRIKA">Centrika</MenuItem>
                  <MenuItem value="OPERATOR">Operator</MenuItem>
                  <MenuItem value="STAKEHOLDER">Stakeholder</MenuItem>
                  <MenuItem value="AGENT">Agent</MenuItem>
                  <MenuItem value="RURA">RURA</MenuItem>
                </Select>
                <FormHelperText>{organizationType.error}</FormHelperText>
              </FormControl>
            </Box>
          )}  
          {commissionType.value == "CUSTOM" || commissionType.value == "FEES_COMM"  ? (
            <Box mt={2}>
              <Autocomplete
                fullWidth
                openOnFocus
                options={orgs}
                getOptionLabel={(option) => option.name}
                onChange={onOrganizationChange}
                disabled={commissions.edit}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label={
                      <Translate id="roles.forms.labels.role_organization" />
                    }
                    variant="outlined"
                    size="small"
                    helperText={organization.error}
                    error={organization.error !== ""}
                  />
                )}
              />
            </Box>
          ):<></>}
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={commissionName.value}
                  placeholder={translate(
                    "commissions.forms.hints.commission_name"
                  )}
                  label={
                    <Translate id="commissions.forms.labels.commission_name" />
                  }
                  fullWidth
                  onChange={onNameChange}
                  helperText={commissionName.error}
                  error={commissionName.error !== ""}
                />
              )}
            </Translate>
          </Box>
          {commissionType.value != "FEES_COMM" && (<Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                commissionTransactionType.error !== "" ||
                transactionTypes?.status == "error"
              }
              disabled={
                transactionTypes?.status != "success" || commissions.edit
              }
            >
              <InputLabel>
                <Translate id="commissions.forms.labels.commission_transaction_type" />
              </InputLabel>
              <Select
                label={
                  <Translate id="commissions.forms.labels.commission_transaction_type" />
                }
                value={commissionTransactionType.value}
                onChange={onTransactionTypeChange}
              >
                {transactionTypes?.data?.map((tr, i) => (
                  <MenuItem value={tr.code}>{tr.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {transactionTypes?.status == "error"
                  ? "Error loading transaction types, try refreshing"
                  : commissionTransactionType.error}
              </FormHelperText>
            </FormControl>
          </Box>) }
        
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={commissionComputationMode.error !== ""}
            >
              <InputLabel>
                <Translate id="commissions.forms.labels.commission_computation_mode" />
              </InputLabel>
              <Select
                label={
                  <Translate id="commissions.forms.labels.commission_computation_mode" />
                }
                value={commissionComputationMode.value}
                onChange={onComputationModeChange}
              >
                {["PERCENTAGE", "FIXED"].map((mode, i) => (
                  <MenuItem value={mode}>{mode}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{commissionComputationMode.error}</FormHelperText>
            </FormControl>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={commissionValue.value}
                  placeholder={translate(
                    "commissions.forms.hints.commission_value"
                  )}
                  label={
                    <Translate id="commissions.forms.labels.commission_value" />
                  }
                  fullWidth
                  onChange={onValueChange}
                  helperText={commissionValue.error}
                  error={commissionValue.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={commissionVat.value}
                  placeholder={translate(
                    "commissions.forms.hints.commission_vat"
                  )}
                  label={
                    <Translate id="commissions.forms.labels.commission_vat" />
                  }
                  fullWidth
                  onChange={onVatChange}
                  helperText={commissionVat.error}
                  error={commissionVat.error !== ""}
                />
              )}
            </Translate>
          </Box>
          {commissionType.value != "FEES_COMM" && (<Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                commissionDebitedAccountNumber.error !== "" ||
                internalAccounts.status == "error"
              }
            >
              <InputLabel>
                <Translate id="commissions.forms.labels.commission_debited_account_number" />
              </InputLabel>
              <Select
                label={
                  <Translate id="commissions.forms.labels.commission_debited_account_number" />
                }
                value={commissionDebitedAccountNumber.value}
                onChange={onDebitedAccountNumberChange}
              >
                {internalAccounts?.data?.map((acc, i) => (
                  <MenuItem value={acc.account_number}>
                    {acc.account_name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {internalAccounts.status == "error"
                  ? "Error getting internal accounts, please reload"
                  : commissionDebitedAccountNumber.error}
              </FormHelperText>
            </FormControl>
          </Box>)}
          {commissionType.value == "FEES_COMM" && (
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={bankAccountName.value}
                    placeholder={"Bank Account Holder"}
                    label={"Bank Account Holder"}
                    fullWidth
                    onChange={onBankAccountName}
                    helperText={bankAccountName.error}
                    error={bankAccountName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          )}

          {commissionType.value == "FEES_COMM" && (
           <Box mt={2}><FormControl
            fullWidth
            variant="outlined"
            size="small"
            error={bankCode.error !== ""}
          //  disabled={!operators.edit}
          >
            <InputLabel>
              <Translate id="operators.forms.labels.operator_settlement_bank_code" />
            </InputLabel>
            <Select
              label={
                <Translate id="operators.forms.labels.operator_settlement_bank_code" />
              }
              value={bankCode.value}
              onChange={onBankCode}
            >
              {new AdminService()
                .getBankCodes()
                .map((loc, i) => (
                  <MenuItem value={loc.code}>
                    {loc.name}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText>
              {bankCode.error}
            </FormHelperText>
          </FormControl></Box>)}

          {commissionType.value == "FEES_COMM" && (
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={bankAccount.value}
                    placeholder={"Bank Account Number"}
                    label={"Bank Account Number"}
                    fullWidth
                    onChange={onBankAccount}
                    helperText={bankAccount.error}
                    error={bankAccount.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          )}
          
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setCommissions({ ...commissions, open: false });
            }}
            variant="outlined"
            color="primary"
          >
            <Translate id="agents.forms.buttons.cancel" />
          </Button>
          <Button
            disabled={commissions.saving}
            variant="contained"
            color="primary"
            onClick={onCreateClick}
            disableElevation
          >
            {commissions.saving ? (
              <CircularProgress size={23} />
            ) : commissions.edit ? (
              "Save"
            ) : (
              <Translate id="commissions.forms.buttons.create" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Box display="flex" alignItems="center">
        <Box mr={2}>
          {" "}
          <Group color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Accounts</b>
          </Typography>
          <Box ml={1} mr={1} mt={1}>
            <ArrowForwardIos fontSize="small" />
          </Box>
          <Typography variant="h6">Commissions</Typography>
        </Box>

        <Box display="flex">
          <Button
            className={classes.btn}
            color="primary"
            variant="outlined"
            size="medium"
            startIcon={<Assignment />}
            disableElevation
            onClick={() => setTypesOpen(true)}
          >
            Commission types
          </Button>
          <Box pl={2} />
          <Button
            className={classes.btn}
            color="primary"
            variant="contained"
            size="medium"
            startIcon={<Add />}
            disableElevation
            onClick={() => setCommissions({ ...commissions, open: true })}
          >
            New commission
          </Button>
        </Box>
      </Box>
      <Box mt={3} />
      <Grid container spacing={1}>
        <Grid xs={12}>
          <Box m={2}>
            <Typography color="textSecondary">
              Create generic and custom commissions
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          {!commissions.loading && commissions.data.length == 0 ? (
            <Box
              p={3}
              height={1}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Box mt={2}>
                <img src={Nodata} alt="Empty data" height={200} />
              </Box>

              <Typography color="textSecondary">
                There are no commissions available, create one first
              </Typography>
            </Box>
          ) : (
            <Paper elevation={0} style={{ minHeight: 350 }}>
              <List>
                {!commissions.loading
                  ? commissions.data.map((comm, i) => (
                      <ListItem
                        key={i}
                        button
                        selected={commissions.index == i}
                        onClick={() => {
                          setCommissions({
                            ...commissions,
                            selected: comm,
                            index: i,
                          });
                        }}
                      >
                        <ListItemIcon>
                          <DonutLarge />
                        </ListItemIcon>
                        <ListItemText primary={comm.name} />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            checked={comm.status == "ENABLED"}
                            value={i}
                            disabled={commissions.toggling == i}
                            onChange={() => {
                              toggleCommissionStatus(comm.id, i, comm.status);
                            }}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))
                  : [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, i) => (
                      <ListItem key={i}>
                        <ListItemIcon>
                          <Skeleton variant="circle" width={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Skeleton
                              variant="text"
                              width={"100%"}
                              style={{ borderRadius: 7 }}
                            />
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          {commissions.selected == "none" ? (
            <Box
              height={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
            >
              <img src={SelectImg} alt="select item" height={200} />
              <Typography color="textSecondary" align="center">
                Select one commission for more info
              </Typography>
            </Box>
          ) : (
            <Box height={1} mx={2}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="h5">
                  {commissions.selected.name}
                </Typography>

                <IconButton
                  color="primary"
                  onClick={() =>
                    setCommissions({
                      ...commissions,
                      selected: "none",
                      index: "none",
                    })
                  }
                >
                  <Close />
                </IconButton>
              </Box>
              <Button
                variant="outlined"
                color="primary"
                className={classes.btn}
                disableElevation
                startIcon={<Edit />}
                onClick={() => {
                  setOrganizationType({
                    value: commissions.selected.organization_type,
                    error: "",
                  });

                  var code1 = commissionTypes.data?.filter(
                    (obj) => obj.id == commissions.selected.commission_type_id
                  )[0]?.code;

                  setType({
                    value: code1,
                    error: "",
                  });

                  setName({ value: commissions.selected.name, error: "" });

                  var code = transactionTypes.data?.filter(
                    (obj) => obj.id == commissions.selected.transaction_type_id
                  )[0]?.code;

                  setTransactionType({
                    value: code,
                    error: "",
                  });
                  setOrganization({ value: {}, error: "" });
                  setComputationMode({
                    value: commissions.selected.computation_mode,
                    error: "",
                  });
                  setVat({ value: commissions.selected.vat, error: "" });
                  setValue({
                    value: commissions.selected.commission_value,
                    error: "",
                  });
                  setDebitedAccountNumber({
                    value: commissions.selected.debited_account_number,
                    error: "",
                  });
                  setBankAccount(
                    { value: commissions.selected.credited_bank_account,
                    error: ""}
                  );
                  setBankAccountName({
                    value: commissions.selected.credited_bank_name,
                    error: ""
                  })
                  setBankCode({
                    value: commissions.selected.credited_bank_code,
                    error: ""
                  })

                  setCommissions({
                    ...commissions,
                    open: true,
                    edit: true,
                  });
                }}
              >
                Edit commission
              </Button>
              <Grid container>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography>Commission for: </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography color="textSecondary">
                      {commissions.selected.organization_type}
                    </Typography>
                  </Box>
                </Grid>
                {/* // */}

                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography>Commission value: </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography color="textSecondary">
                      {commissions.selected.commission_value}
                    </Typography>
                  </Box>
                </Grid>
                {/* // */}
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography>Mode: </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography color="textSecondary">
                      {commissions.selected.computation_mode}
                    </Typography>
                  </Box>
                </Grid>
                {/* // */}
                  {commissions.selected.commission_type_id !== 3 && <>                
                  <Grid item xs={6}>
                    <Box mt={2} display="flex">
                      <Typography>Debitted from: </Typography>
                    </Box>
                  </Grid>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography color="textSecondary">
                          {commissions.selected.debited_account_number}
                        </Typography>
                      </Box>
                    </Grid></>}

                  {commissions.selected.commission_type_id == 3 && <>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography>Bank Account: </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography color="textSecondary">
                          {commissions.selected.credited_bank_account}
                        </Typography>
                      </Box>
                    </Grid></>}

                  {commissions.selected.commission_type_id == 3 && <>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography>Bank Account Holder: </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography color="textSecondary">
                          {commissions.selected.credited_bank_name}
                        </Typography>
                      </Box>
                    </Grid></>}

                {/* // */}

                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography>Commission type: </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography color="textSecondary">
                      {
                        commissionTypes.data?.filter(
                          (obj) =>
                            obj.id == commissions.selected.commission_type_id
                        )[0]?.name
                      }
                    </Typography>
                  </Box>
                </Grid>
                {/* // */}
                {commissions.selected.commission_type_id !== 3 && <>                 
                  <Grid item xs={6}>
                    <Box mt={2} display="flex">
                      <Typography>Transaction type: </Typography>
                    </Box>
                  </Grid>
                    <Grid item xs={6}>
                      <Box mt={2} display="flex">
                        <Typography color="textSecondary">
                          {
                            transactionTypes.data?.filter(
                              (obj) =>
                                obj.id == commissions.selected.transaction_type_id
                            )[0]?.name
                          }
                        </Typography>
                      </Box>
                    </Grid></> }
                {/* // */}
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography>Status: </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2} display="flex">
                    <Typography
                      color={
                        commissions.selected.status == "ENABLED"
                          ? "primary"
                          : "error"
                      }
                    >
                      {commissions.selected.status}
                    </Typography>
                  </Box>
                </Grid>
                {/* // */}
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

const AccountCommisions = withLocalize(Commissions);
export { AccountCommisions };
